export default class CustomSelect {
  constructor($_selects) {
    this.selects = $_selects;

    this.transformSelects();
    this.clickAnywhare();
  }

  transformSelects() {
    this.selects.map(($_item) => {
      this.init($_item);
    });
  }

  init($_select) {
    const $_selected_content = $_select.querySelector(
      ".custom-select__selected"
    );
    const $_options = $_select.querySelector(".custom-select__options");
    this.setSelectedValue($_select);
    this.toogleSelectClickListener($_selected_content, $_options);
    this.selectOption($_select);
    this.afterInit($_select);
  }

  afterInit($_select) {
    const $_selected_content = $_select.querySelector(
      ".custom-select__selected"
    );
    $_selected_content.classList.remove("custom-select__selected--hide");
  }

  setSelectedValue($_select) {
    const $_option_selected = $_select.querySelector(
      '.custom-select__options__item[data-selected="selected"]'
    );
    if ($_option_selected) {
      this.setValue($_select, $_option_selected.textContent.trim());
    }
  }

  toogleSelectClickListener($_button, $_options) {
    $_button.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toogleOptions($_options);
    });
  }

  toogleOptions($_options) {
    $_options.classList.toggle("custom-select__options--hide");
  }

  selectOption($_select) {
    $_select.addEventListener("click", (e) => {
      e.stopPropagation();
      const select = e.target.classList.contains(
        "custom-select__options__item"
      );
      if (select) {
        const value = e.target.dataset.value;
        const value_text = e.target.innerText;
        const $_options = $_select.querySelector(".custom-select__options");
        const $_original_select = $_select.nextElementSibling;

        this.toogleOptions($_options);
        this.setValue($_select, value_text);
        if ($_original_select) {
          this.setValueInOriginalSelect($_original_select, value);
        }

        if ($_select.dataset.config === "sort") {
          this.selectSort(value);
        }
      }
    });
  }

  setValue($_select, value) {
    const $_selected_value = $_select.querySelector(
      ".custom-select__selected__value"
    );
    $_selected_value.innerText = value;
  }

  setValueInOriginalSelect($_original_select, value) {
    const $_options = $_original_select.querySelectorAll("option");
    [...$_options].map((item) => {
      if (item.value === value) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
  }

  selectSort(value) {
    // const url_string = `${document.location.origin}${document.location.pathname}`
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set("sort_by", value);
    const params = searchParams.toString();
    // url.params = params
    // history.pushState({ params }, '', `${window.location.pathname}${params && '?'.concat(params)}`);
    // console.log(url);
    // console.log(`${window.location.pathname}${params && '?'.concat(params)}`);
    // url.searchParams.append('sort_by', value);
    window.location.href = `${window.location.pathname}${
      params && "?".concat(params)
    }`;
  }

  clickAnywhare() {
    document.addEventListener("click", () => this.closeAllSelect());
  }

  closeAllSelect() {
    this.selects.map(($_select) => {
      const $_options = $_select.querySelector(
        ".custom-select__options:not(.custom-select__options--hide)"
      );
      if ($_options) {
        this.toogleOptions($_options);
      }
    });
  }
}
